import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { TNavigationItemChildren } from '../../types';
import { fade } from 'src/app/animations';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import Subscriber from 'src/app/subscriber';

const sub = new Subscriber();

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  animations: [fade()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationItemComponent implements OnDestroy {
  @Input() title?: string;

  @Input() link?: string;

  @Input() href?: string;

  @Input() target: '_blank' | '_self' | '_parent' | '_top' = '_self';

  @Input() svgIconSrc?: string;

  @Input() children: TNavigationItemChildren = [];

  @Input() label?: string | number;

  private _isDropdownActive = new BehaviorSubject(false);

  public isDropdownActive = this._isDropdownActive.asObservable();

  private _dropdownTimer?: number;

  constructor(private router: Router) {
    sub.push(
      this.router.events.subscribe((/* event */) => {
        this._isDropdownActive.next(false);
      }),
    );
  }

  ngOnDestroy(): void {
    sub.unsubscribe();
  }

  @HostListener('mouseenter')
  private _onMouseenter(): void {
    window.clearTimeout(this._dropdownTimer);

    this._isDropdownActive.next(true);
  }

  @HostListener('mouseleave')
  private _onMouseleave(): void {
    this._dropdownTimer = window.setTimeout(() => {
      this._isDropdownActive.next(false);

      delete this._dropdownTimer;
    }, 200);
  }
}
